import { render, staticRenderFns } from "./ProcessHero.vue?vue&type=template&id=766f2920&"
import script from "./ProcessHero.vue?vue&type=script&lang=js&"
export * from "./ProcessHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports